export class NoPermissinError extends Error {
  constructor(msg: string) {
    super(msg);
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, NoPermissinError.prototype);
  }
}
